import AddIcon from "@mui/icons-material/Add";
import GroupsSharpIcon from "@mui/icons-material/GroupsSharp";
import { Box, Typography, useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useCallback } from "react";
import { DISPLAY_MODE_COMMITTEE } from "./sourcings-page";
import Highlight from "components/ui/atoms/Highlight";
import {
  TopRightMenu,
  TopRightMenuItem,
} from "components/ui/molecules/TopRightMenu";
import { useModal } from "@ebay/nice-modal-react";

const SourcingHeader = ({ displayMode, setDisplayMode }) => {
  const theme = useTheme();
  const SourcingModal = useModal("SourcingDrawer");

  const toggleDisplayMode = useCallback(
    (newDisplayMode) => {
      if (newDisplayMode === displayMode) setDisplayMode("");
      else setDisplayMode(newDisplayMode);
    },
    [displayMode],
  );

  return (
    <>
      <Box>
        <Typography variant="h1" component="span">
          Sourcing
        </Typography>
      </Box>
      <TopRightMenu style={{ marginLeft: "auto" }}>
        <TopRightMenuItem
          endIcon={<AddIcon sx={{ scale: "0.8" }} />}
          onClick={() => SourcingModal.show({ formType: "create" })}
        >
          Create
        </TopRightMenuItem>
        <TopRightMenuItem
          selected={displayMode == DISPLAY_MODE_COMMITTEE}
          onClick={() => toggleDisplayMode(DISPLAY_MODE_COMMITTEE)}
          endIcon={<GroupsSharpIcon sx={{ scale: "0.8" }} />}
          alwaysShow
        >
          Committee
        </TopRightMenuItem>
      </TopRightMenu>
    </>
  );
};

export default SourcingHeader;
